import { render } from "./AdminTickets.vue?vue&type=template&id=10e93ed6"
import script from "./AdminTickets.vue?vue&type=script&lang=js"
export * from "./AdminTickets.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__